<template>
  <div
    class="model-container"
    :id="content.key"
  >
    <el-image
      class="image"
      :id="`${content.key}-1`"
      :src="content.collectionCover.img"
      :style="{
        width: canSetWidth ? content.collectionCover.width : ''
      }"
      @click="threeDPopupShow"
    ></el-image>
    <p
      class="model-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.collectionCover.titleStyle.fontFamily || '',
        fontSize: (content.collectionCover.titleStyle.fontSize + 'px') || '',
        lineHeight: (content.collectionCover.titleStyle.lineHeight + 'px') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.collectionCover.titleStyle.fontWeight || '',
        textDecoration: content.collectionCover.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.collectionCover.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.collectionCover.titleStyle.textAlign || '',
        color: content.collectionCover.titleStyle.color || '',
        backgroundColor: content.collectionCover.titleStyle.backgroundColor || '',
      }"
    >{{ content.collectionCover.title }}</p>
    <threeDPopup
      :dialogTitle="dialogTitle"
      :dialogVisible="dialogVisible"
      :threeDList="content.content"
      :showInFullPage="true"
      :showInNewPage="true"
      @dialogClose="dialogClose"
    ></threeDPopup>
  </div>
</template>

<script>
/*
三维模型集合的封面样式
*/
import threeDPopup from "../../popup/threeDList.vue";
export default {
  name: "threeDUnitCollection",
  components: {
    threeDPopup
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    canSetWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false
    }
  },
  methods: {
    threeDPopupShow() {
      this.dialogVisible = true
    },
    dialogClose() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.model-container {
  width: 100%;

  .image{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 10px;
    cursor: pointer;
  }

  .model-title{
    display: block;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #00a8ac;
  }
}
</style>